import { EditorState, Transaction } from "prosemirror-state";
import { getTopLevelParagraphsAndHeadings } from "./GetNodes";

function setAlignmentFactory(alignment: string) {
	return function setAlignment(state: EditorState, dispatch?: (tx: Transaction) => void) {
		const pp = getTopLevelParagraphsAndHeadings(state);
		if (dispatch) {
			const tr = state.tr;
			let did = false;
			// first try: move everyone to this alignment
			for (const p of pp) {
				if (p.node.attrs.align !== alignment) {
					tr.setNodeMarkup(p.pos, p.node.type, {
						align: alignment,
						indent: p.node.attrs.indent,
						...(p.node.attrs.level && { level: p.node.attrs.level }),
					});
					did = true;
				}
			}

			// second try: nothing happened, so everything must be on the desired alignment already
			// if that alignment is right or center, move to left
			if (!did && alignment !== "left") {
				for (const p of pp) {
					tr.setNodeMarkup(p.pos, p.node.type, {
						align: "left",
						indent: p.node.attrs.indent,
						...(p.node.attrs.level && { level: p.node.attrs.level }),
					});
				}
				did = pp.length > 0;
			}
			if (did) {
				dispatch(tr.scrollIntoView());
			}
			return did;
		} else {
			for (const p of pp) {
				if (p.node.attrs.align !== alignment) {
					return true;
				}
			}
			if (alignment !== "left") {
				return pp.length > 0;
			}
			return false;
		}
	};
}

/** Set text alignment in all selected paragraphs to left */
export const alignLeft = setAlignmentFactory("left");
/** Set text alignment in all selected paragraphs to center */
export const alignCenter = setAlignmentFactory("center");
/** Set text alignment in all selected paragraphs to right */
export const alignRight = setAlignmentFactory("right");
/** Set text alignment in all selected paragraphs to justify */
export const alignJustify = setAlignmentFactory("justify");

function alignmentActiveFactory(alignment: string) {
	return function isActive(state: EditorState) {
		const pp = getTopLevelParagraphsAndHeadings(state);
		return pp.length > 0 && pp.every(p => p.node.attrs.align === alignment);
	};
}

export const alignLeftActive = alignmentActiveFactory("left");
export const alignCenterActive = alignmentActiveFactory("center");
export const alignRightActive = alignmentActiveFactory("right");
export const alignJustifyActive = alignmentActiveFactory("justify");
